import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { uploadNFTImage, uploadNFTImage2 } from '../../helpers/nftHelper';
import Common from '../../helpers/common.helper';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { fetchUserProfile } from '../../actions/profile_action';
import { isValidImageFile } from '../../utils/utils';
import { defaultBrokenImage, defaultLogo } from '../../assets/images';
import useWallets from '../../wallet-module/hooks/useWallets';
import { REACT_APP_S3_CLOUDFLARE_ASSETS_URL, socialsLogo } from '../../utils/consts';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import ModalDisconnectSocial from './create_nft/modals/ModalDisconnectSocial';
import ModalConnectSocial from './create_nft/modals/ModalConnectSocial';

const ProfileSettings = (props) => {
  let { profile } = props;
  const [is_loading_profile, setIsLoadingProfile] = useState(false);
  const [isDisconnectSocial, setIsDisconnectSocial] = useState(false);
  const [restrictedSites, setRestrictedSites] = useState([]);
  const [isConnectSocial, setIsConnectSocial] = useState(false);
  const [connectedService, setConnectedService] = useState(localStorage?.getItem('service') ?? '');
  const [is_loading_banner, setIsLoadingBanner] = useState(false);
  const [is_submiting, setIsSubmiting] = useState(false);
  const [imgUrl, setImgUrl] = useState('');
  const [isCopied, setIsCopied] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [bannerImgUrl, setBannerImgUrl] = useState('');
  const hiddenFileInputProfile = useRef(null);
  const hiddenFileInputBanner = useRef(null);
  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { vanarAddressLowerCase } = useWallets();

  const [loading, setLoading] = useState(false);
  const storedSocials = localStorage.getItem('socials');
  const initialState = storedSocials
    ? JSON.parse(storedSocials)
    : [];

  const [socialLogin, setSocialLogin] = useState(initialState);

  const [viewSocials, setViewSocials] = useState(profile?.data?.viewSocials ?? true);
  const [formData, setFormData] = useState({
    username: '',
    bio: '',
    links: '',
    socials: [],
    viewSocials: viewSocials,
  });
  const searchParams = new URLSearchParams(window.location.search);

  const navigate = useNavigate();
  const handleChangeDetails = (e) => {
    let hasspaces = /^\s+/.test(e.target?.value);
    if (hasspaces) {
      setIsUpdated(false);
    } else {
      setIsUpdated(true);
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };
  const handleChange = async (event) => {
    setIsUpdated(true);
    const fileUploaded = event.target.files[0];
    if (fileUploaded) {
      // Check the file size (max size: 50MB)
      const maxSizeInBytes = 50 * 1024 * 1024; // 50MB
      if (fileUploaded.size > maxSizeInBytes) {
        alert('File size exceeds the maximum limit of 50MB. Please choose a smaller file.');
        event.target.value = null; // Clear the input
        return;
      }

      const check = await isValidImageFile(fileUploaded);
      if (check) {
        setIsLoadingProfile(true);
        const token = await executeRecaptcha('UsersImages');
        await uploadNFTImage2(fileUploaded, 'user_images', token).then(async (res) => {
          setImgUrl(res);
          await Common.setDocument('users', profile.data.wallet_address, { image: res }).then(
            (res) => {
              setIsLoadingProfile(false);
            },
          );
        });
      } else {
        event.target.value = null; // Clear the input
        return;
      }
    }
  };

  const handleChangeBanner = async (event) => {
    setIsUpdated(true);
    const fileUploaded = event.target.files[0];
    if (fileUploaded) {
      // Check the file size (max size: 50MB)
      const maxSizeInBytes = 50 * 1024 * 1024; // 50MB
      if (fileUploaded.size > maxSizeInBytes) {
        alert('File size exceeds the maximum limit of 50MB. Please choose a smaller file.');
        event.target.value = null; // Clear the input
        return;
      }

      const check = await isValidImageFile(fileUploaded);

      if (check) {
        setIsLoadingBanner(true);
        const token = await executeRecaptcha('UsersImagesBanner');
        await uploadNFTImage2(fileUploaded, 'user_images', token).then(async (res) => {
          setBannerImgUrl(res);
          await Common.setDocument('users', profile.data.wallet_address, {
            banner_image: res,
          }).then(() => {
            setIsLoadingBanner(false);
          });
        });
      } else {
        event.target.value = null; // Clear the input
        return;
      }
    }
  };
  const handleClickProfile = (event) => {
    hiddenFileInputProfile.current.click();
  };
  const handleClickBanner = (event) => {
    hiddenFileInputBanner.current.click();
  };
  const updateProfile = async (e) => {
    e.preventDefault();
    setIsSubmiting(true);
    const isValidUrl = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/.test(formData.links);
    const site = formData.links?.split('/')[2]

    if (formData.links.length > 0 && !isValidUrl) {
      toast('Please enter a valid url');
      setIsSubmiting(false);
    } else if (restrictedSites.includes(site)) {
      toast('Unable to add website due to explicit content');
      setIsSubmiting(false);
    } else if (formData?.username?.length === 0) {
      toast('Username cannot be empty');
      setIsSubmiting(false);
    } else if (formData?.username?.length < 4 && formData?.username?.length !== 0) {
      toast('Your username should be between 4 and 16 characters long');
      setIsSubmiting(false);
    } else {
      try {
        socialLogin?.forEach(async (e) => {
          if (e?.id) {
            switch (e.service) {
              case 'discord':
                await Common.logEvent(
                  vanarAddressLowerCase,
                  'isBazaaDicordConnectedProfile',
                  'Bazaa',
                );
                break;
              case 'twitter':
                await Common.logEvent(vanarAddressLowerCase, 'isBazaaXConnectedProfile', 'Bazaa');
                break;
              default:
                break;
            }
          }
        });
        await Common.setDocument('users', profile.data.wallet_address, formData).then(() => {
          setIsSubmiting(false);
          toast('Profile Updated');
          setIsUpdated(false);
          dispatch(fetchUserProfile(vanarAddressLowerCase));
          navigate('/my-profile');
        });
        localStorage.removeItem('isConnecting');
        localStorage.removeItem('socials');
        localStorage.removeItem('loadingIndex');
      } catch (error) {
        console.error('Error Updating Profile', error);
        setIsSubmiting(false);
      }
    }
  };

  const fetchRestrictedSites = async () => {
    const data = await Common.getSingleDocument('/dictionary', '/restricted_sites');
    setRestrictedSites(data.sites);
  };

  useEffect(() => {
    if (!window.location.search?.length > 0) {
      setSocialLogin([
        {
          service: 'twitter',
          id: null,
          username: '',
        },
        {
          service: 'discord',
          id: null,
          username: '',
        },
      ]);
          localStorage.setItem(
      'socials',
      JSON.stringify([
        {
          service: 'twitter',
          id: null,
          username: '',
        },
        {
          service: 'discord',
          id: null,
          username: '',
        },
      ]),
    );
    }
  }, []);

  useEffect(() => {
    fetchRestrictedSites();
  }, []);

  useEffect(() => {
    const hasUsername = profile?.data?.socials?.some((e) => e?.username.length > 0);
    const isConnecting = localStorage.getItem('isConnecting');
    if (hasUsername) {
      localStorage?.setItem('socials', JSON.stringify(profile?.data?.socials));
      setSocialLogin(profile?.data?.socials);
    }
    if (isConnecting) {
      setIsUpdated(true);
    }
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
      username: profile?.data?.username,
      bio: profile?.data?.bio || '',
      links: profile?.data?.links || '',
      socials: socialLogin || profile?.data?.socials || [],
      viewSocials: viewSocials || profile?.data?.viewSocials,
    });
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 5000);
    }
  }, [profile?.data, isCopied, socialLogin]);

  useEffect(() => {
    if (!vanarAddressLowerCase) {
      navigate('/');
    }
  }, [vanarAddressLowerCase]);

  useEffect(() => {
    const code = searchParams.get('code');
    const error = searchParams.get('error');

    if (code) {
      const service = localStorage?.getItem('service');
      verifyToken(code, service);
    }
    if ((!code && loadingIndex !== null) || error) {
      toast('Something went wrong, Please try later');
      localStorage.removeItem('loadingIndex');
      setLoadingIndex(null);
      window.history.replaceState(null, null, window.location.pathname);
    }
  }, []);

 

  const storedIndex = localStorage?.getItem('loadingIndex');
  const [loadingIndex, setLoadingIndex] = useState(
    storedIndex ? Number(localStorage?.getItem('loadingIndex')) : null,
  );

  const verifyToken = async (code, service) => {
    setLoading(true);
    const socials = await Common.verify(
      code,
      service,
      vanarAddressLowerCase,
      socialLogin,
      window.location.href,
    );
    setSocialLogin(socials);
    setIsUpdated(true);
    setLoading(false);
    localStorage.removeItem('loadingIndex');
    setLoadingIndex(null);
  };

  return (
    <div id="wrapper">
      <section aria-label="section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="setting_text">Profile Settings</h2>
            </div>
          </div>
          <div>
            <div className="profile_container banner_image" style={{ borderRadius: '12px' }}>
              {is_loading_banner ? (
                <Spinner animation="border" role="status" />
              ) : (
                <>
                  <img
                    src={
                      bannerImgUrl ||
                      profile?.data?.banner_image ||
                      `${REACT_APP_S3_CLOUDFLARE_ASSETS_URL}banner-placeholder.svg`
                    }
                    alt=""
                    style={{ borderRadius: '12px' }}
                  />
                  <div className="overlay" style={{ borderRadius: '12px' }}>
                    <span className="icon pointer" title="User Profile" onClick={handleClickBanner}>
                      <i className="fa fa-edit" />
                    </span>
                  </div>
                </>
              )}
              <input
                type="file"
                accept="image/*"
                onChange={handleChangeBanner}
                name="profile"
                ref={hiddenFileInputBanner}
                style={{ display: 'none' }}
              />
            </div>
          </div>
          <div className="user_image_upload">
            <div className="profile_container max-content">
              {is_loading_profile ? (
                <div className="overlay-loader">
                  <Spinner animation="border" role="status" />
                </div>
              ) : (
                <>
                  <div className="image-profile-holder">
                    <img src={imgUrl || profile?.data?.image || defaultBrokenImage} alt="" />
                    <div className="overlay">
                      <span
                        className="icon pointer"
                        title="User Profile"
                        onClick={handleClickProfile}
                      >
                        <i className="fa fa-edit" />
                      </span>
                    </div>
                  </div>
                </>
              )}
              <input
                type="file"
                accept="image/*"
                onChange={handleChange}
                name="profile"
                ref={hiddenFileInputProfile}
                style={{ display: 'none' }} // Make the file input element invisible
              />
            </div>
          </div>
          <div className="row mobile_row">
            <div className="col-lg-5">
              <form className="form-border mb-90" onSubmit={updateProfile}>
                <div className="field-set">
                  <div className="spacer-20" />
                  <h5>Username</h5>
                  <input
                    type="text"
                    name="username"
                    id="name"
                    value={formData.username}
                    className="form-control mb-0"
                    placeholder="Enter username"
                    onChange={handleChangeDetails}
                    maxLength="16"
                  />
                  <div className="spacer-20" />
                  <h5>Bio</h5>
                  <textarea
                    data-autoresize=""
                    name="bio"
                    rows={4}
                    id="item_desc"
                    value={formData.bio}
                    className="form-control mb-0"
                    placeholder="Tell the world your story!"
                    onChange={handleChangeDetails}
                    maxLength="1000"
                  />
                  <div className="spacer-20" />
                  <div className="spacer-20" />
                  <div className="d-flex align-items-center mb-3">
                    <div>
                      <h5>Social Connections</h5>
                      <p>Help collectors verify your account by connecting social accounts</p>
                    </div>
                    <div className="ml-auto">
                      <label class="switch_toggle">
                        <input
                          type="checkbox"
                          checked={viewSocials}
                          onClick={() => {
                            setViewSocials(!viewSocials);
                            setFormData({
                              ...formData,
                              viewSocials: !viewSocials,
                            });
                            setIsUpdated(true);
                          }}
                        />
                        <span class="slider_toggle"></span>
                      </label>
                    </div>
                  </div>

                  {viewSocials && (
                    <>
                      {socialLogin?.length > 0 && (
                        <>
                          {socialLogin?.map((e, i) => (
                            <div key={i}>
                              <div className="d-flex align-items-center">
                                <div className="d-flex align-items-center">
                                  <div className="social_connection">
                                    {socialsLogo[`${e?.service}`]}
                                  </div>
                                  {e?.username ? (
                                    <a
                                      href={Common.viewSocialProfile(e.service, e.id, e.username)}
                                      className="ml10 mb-0 pointer"
                                      target="_blank"
                                    >
                                      {e?.username}
                                    </a>
                                  ) : (
                                    <p className="ml10 mb-0">
                                      {Common.capitalizeFirstLetter(e?.service)}
                                    </p>
                                  )}
                                </div>{' '}
                                <div className="ml-auto">
                                  {e?.username?.length > 0 ? (
                                    <button
                                      className="btn-main transparent"
                                      type="button"
                                      onClick={() => {
                                        setIsDisconnectSocial(true);
                                        setConnectedService(e.service);
                                        setIsUpdated(true);
                                        setLoadingIndex(null);
                                        localStorage.removeItem('loadingIndex');
                                      }}
                                      disabled={!e.username || loading}
                                    >
                                      {loadingIndex === i && !e?.username ? (
                                        <Spinner animation="border" size="sm" role="status" />
                                      ) : (
                                        'Disconnect'
                                      )}
                                    </button>
                                  ) : (
                                    <button
                                      className="btn-main transparent"
                                      type="button"
                                      style={{ width: '130px' }}
                                      onClick={() => {
                                        setConnectedService(e.service);
                                        setIsConnectSocial(true);
                                        setLoadingIndex(i);
                                      }}
                                      disabled={loading}
                                    >
                                      {loadingIndex === i ? (
                                        <Spinner animation="border" size="sm" role="status" />
                                      ) : (
                                        'Connect'
                                      )}
                                    </button>
                                  )}
                                </div>
                              </div>
                              <div className="spacer-20" />
                            </div>
                          ))}
                        </>
                      )}
                      <div class="mb-3 relative">
                        <div className="social_connection social_input">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                          >
                            <path
                              d="M19.5434 4.08859V4.05869H19.522C18.4926 2.79084 17.1933 1.76861 15.7188 1.06647C14.2442 0.364341 12.6316 0 10.9984 0C9.36519 0 7.75256 0.364341 6.27801 1.06647C4.80346 1.76861 3.50415 2.79084 2.47476 4.05869H2.45447V4.08859C0.866725 6.04213 0 8.48269 0 11C0 13.5173 0.866725 15.9579 2.45447 17.9114V17.9413H2.47583C3.50522 19.2092 4.80453 20.2314 6.27908 20.9335C7.75362 21.6357 9.36626 22 10.9995 22C12.6327 22 14.2453 21.6357 15.7199 20.9335C17.1944 20.2314 18.4937 19.2092 19.5231 17.9413H19.5455V17.9114C21.1333 15.9579 22 13.5173 22 11C22 8.48269 21.1333 6.04213 19.5455 4.08859H19.5434ZM11.5324 4.05869V1.14547C12.1652 1.41105 12.7344 1.80813 13.2021 2.31038C13.6697 2.81264 14.0253 3.40858 14.2451 4.05869H11.5324ZM14.6669 5.12658C15.2387 6.85015 15.5458 8.65043 15.5779 10.4661H11.5324V5.12658H14.6669ZM10.4644 1.14547V4.05869H7.75171C7.97152 3.40858 8.32706 2.81264 8.79474 2.31038C9.26242 1.80813 9.83156 1.41105 10.4644 1.14547ZM10.4644 5.12658V10.4661H6.41885C6.45096 8.65043 6.75811 6.85015 7.32985 5.12658H10.4644ZM5.35193 10.4661H1.09385C1.19506 8.53722 1.86054 6.68058 3.00769 5.12658H6.19458C5.66253 6.85762 5.37954 8.65532 5.35193 10.4661ZM5.35193 11.5339C5.37919 13.3446 5.6629 15.1423 6.19458 16.8734H3.00769C1.86054 15.3194 1.19506 13.4628 1.09385 11.5339H5.35193ZM6.41992 11.5339H10.4644V16.8734H7.32985C6.75811 15.1498 6.45096 13.3496 6.41885 11.5339H6.41992ZM10.4644 17.9413V20.8545C9.83156 20.589 9.26242 20.1919 8.79474 19.6896C8.32706 19.1874 7.97152 18.5914 7.75171 17.9413H10.4644ZM11.5324 20.8545V17.9413H14.2451C14.0253 18.5914 13.6697 19.1874 13.2021 19.6896C12.7344 20.1919 12.1652 20.589 11.5324 20.8545ZM11.5324 16.8734V11.5339H15.5779C15.5458 13.3496 15.2387 15.1498 14.6669 16.8734H11.5324ZM16.6449 11.5339H20.9029C20.8017 13.4628 20.1363 15.3194 18.9891 16.8734H15.8022C16.3343 15.1424 16.6173 13.3447 16.6449 11.5339ZM16.6449 10.4661C16.6176 8.65537 16.3339 6.85768 15.8022 5.12658H18.9891C20.1363 6.68058 20.8017 8.53722 20.9029 10.4661H16.6449ZM18.0888 4.05869H15.4177C15.0493 3.12616 14.5293 2.2609 13.8788 1.49788C15.4748 1.98456 16.9227 2.86523 18.0888 4.05869ZM8.11803 1.49788C7.46787 2.26098 6.94824 3.12623 6.58012 4.05869H3.90694C5.07304 2.86523 6.52088 1.98456 8.11696 1.49788H8.11803ZM3.90801 17.9413H6.57905C6.94749 18.8738 7.46749 19.7391 8.11803 20.5021C6.52195 20.0154 5.07411 19.1348 3.90801 17.9413ZM13.8788 20.5021C14.5289 19.739 15.0486 18.8738 15.4167 17.9413H18.0888C16.9227 19.1348 15.4748 20.0154 13.8788 20.5021Z"
                              fill="#263B80"
                            />
                          </svg>
                        </div>
                        <input
                          type="text"
                          class="form-control mb-0"
                          name="links"
                          placeholder="yoursite.io"
                          value={formData.links}
                          aria-label="link"
                          aria-describedby="basic-addon1"
                          onChange={handleChangeDetails}
                        />
                      </div>
                      <div className="spacer-20" />
                    </>
                  )}
                  <h5>Wallet Address</h5>
                  <span class="profile_username">
                    {Common.getTruncatedAddress(
                      profile?.data?.wallet_address ?? profile?.wallet_address ?? '',
                    )}
                    {isCopied ? (
                      <i class="fa fa-check ml10 pointer" aria-hidden="true"></i>
                    ) : (
                      <i
                        class="fa fa-fw ml10 pointer"
                        aria-hidden="true"
                        title="Copy to use copy"
                        onClick={() => {
                          navigator.clipboard.writeText(profile?.data?.wallet_address).then(() => {
                            setIsCopied(true);
                          });
                        }}
                      >
                        
                      </i>
                    )}
                  </span>
                  <div className="spacer-20" />
                  <button
                    style={{ padding: '12px 40px' }}
                    className="btn-main"
                    disabled={!isUpdated || is_submiting}
                  >
                    {is_submiting ? <Spinner animation="border" size="sm" role="status" /> : 'Save'}
                  </button>
                </div>
              </form>
              {isDisconnectSocial && (
                <ModalDisconnectSocial
                  isDisconnectSocial={isDisconnectSocial}
                  setIsDisconnectSocial={setIsDisconnectSocial}
                  socialLogin={socialLogin}
                  setSocialLogin={setSocialLogin}
                  connectedService={connectedService}
                />
              )}
            </div>
          </div>
        </div>
      </section>
      {isConnectSocial && (
        <ModalConnectSocial
          isConnectSocial={isConnectSocial}
          setIsConnectSocial={setIsConnectSocial}
          service={connectedService}
          vanarAddressLowerCase={vanarAddressLowerCase}
          index={loadingIndex}
          setLoadingIndex={setLoadingIndex}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps)(ProfileSettings);
